export const helperMethods = {
    methods: {
        $_addToUrl(url, stringToAdd) {
            if (!url) {
                return;
            }
            const array = url.split("upload/");
            array.splice(1, 0, "upload/" + stringToAdd + "/");
            const urlString = array.join("");

            return urlString;
        },
        $_appendToUrl(url, stringToAppend) {
            return url + stringToAppend;
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/helpers.js